$(function () {
    $(document).ready(function () {
        $('.wt-pop-out-box').click(function () {
            $(this).toggleClass('expand');
        });
    });
});